import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Clock, AlertCircle } from 'lucide-react';
const events = [{
  id: 1,
  type: 'success',
  title: 'Backlink Acquired',
  domain: 'nytimes.com',
  time: '2 hours ago',
  da: 94
}, {
  id: 2,
  type: 'pending',
  title: 'Email Opened',
  domain: 'forbes.com',
  time: '5 hours ago',
  da: 92
}, {
  id: 3,
  type: 'warning',
  title: 'Link Lost',
  domain: 'old-blog.com',
  time: '1 day ago',
  da: 24
}, {
  id: 4,
  type: 'success',
  title: 'Backlink Acquired',
  domain: 'medium.com',
  time: '2 days ago',
  da: 88
}];
export function BacklinkTimeline() {
  return <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6" data-id="element-27">
      <h3 className="text-lg font-semibold text-white mb-6 flex items-center gap-2" data-id="element-28">
        <span className="w-1 h-4 bg-amber-500 rounded-full" data-id="element-29" />
        Recent Activity
      </h3>

      <div className="relative pl-4 space-y-6 before:absolute before:left-4 before:top-2 before:bottom-2 before:w-px before:bg-white/10" data-id="element-30">
        {events.map((event, index) => <motion.div key={event.id} initial={{
        opacity: 0,
        x: -10
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.4 + index * 0.1
      }} className="relative pl-6" data-id="element-31">
            <div className={`absolute left-0 -translate-x-[5px] top-1 w-2.5 h-2.5 rounded-full border-2 border-[#1a1a1a] ${event.type === 'success' ? 'bg-green-500' : event.type === 'pending' ? 'bg-amber-500' : 'bg-red-500'}`} data-id="element-32" />

            <div className="flex items-start justify-between" data-id="element-33">
              <div data-id="element-34">
                <p className="text-sm font-medium text-white" data-id="element-35">{event.title}</p>
                <p className="text-xs text-amber-500/80 mt-0.5" data-id="element-36">
                  {event.domain}
                </p>
              </div>
              <span className="text-xs font-mono text-white/30 bg-white/5 px-1.5 py-0.5 rounded" data-id="element-37">
                DA {event.da}
              </span>
            </div>
            <p className="text-xs text-white/30 mt-1" data-id="element-38">{event.time}</p>
          </motion.div>)}
      </div>
    </div>;
}